import { useMutation } from "@tanstack/react-query";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import type { DiagramComponent, DiagramInfo } from "@/types/diagram";
import { apiFetch } from "@/lib/api-client";

type UpdateDiagramRequest = {
  id: string;
  name: string;
  description: string;
  diagramComponents: DiagramComponent[];
  svgContent: string;
  uuid: string;
};

const updateDiagram = async (
  payload: UpdateDiagramRequest & { token: string }
): Promise<DiagramInfo | undefined> => {
  const url = `${config.isometricApiUrl}/diagram/${payload.id}`;

  const body = {
    name: payload.name,
    version: "1.0.0",
    metadata: {
      description: payload.description,
      svgContent: payload.svgContent,
    },
    uuid: payload.uuid,
    diagramComponents: payload.diagramComponents,
  };
  try {
    const response = await apiFetch(url, {
      method: "PUT",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });

    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    return await response.json();
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export default function useUpdateDiagram(
  onSettled?: (res: any | undefined, error: Error | null) => void
) {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (params: UpdateDiagramRequest) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace("Bearer ", "");
      return updateDiagram({ ...params, token });
    },
    onSettled,
  });
}
